var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabletAroundScmpPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 704,
  height: 430,
  viewBox: "0 0 704 430",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 704,
  y1: 0.501099,
  x2: -4.37113e-8,
  y2: 0.501037,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.001,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.001,
  width: 213.333,
  height: 10,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 85.001,
  width: 213.333,
  height: 144,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 241.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 308.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 375.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 245.334,
  y: 63.001,
  width: 213.333,
  height: 10,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 245.334,
  y: 85.001,
  width: 213.333,
  height: 144,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 245.334,
  y: 241.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 245.334,
  y: 308.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 245.334,
  y: 375.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 490.666,
  y: 63.001,
  width: 213.333,
  height: 10,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 490.666,
  y: 85.001,
  width: 213.333,
  height: 144,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 490.666,
  y: 241.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 490.666,
  y: 308.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 490.666,
  y: 375.001,
  width: 213.333,
  height: 55,
  fill: "#E5E5E5"
})));
export default SvgTabletAroundScmpPlaceholder;